export default {
  ringtones: 'Ringtones',
  incomingRingtone: 'Incoming Ringtone',
  outgoingRingtone: 'Outgoing Ringtone',
  play: 'Play',
  stop: 'Stop',
  upload: 'Upload',
  reset: 'Reset',
  save: 'Save',
} as const;
